import qs from 'querystring';
import Ajv from 'ajv';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

// api response transform functions go here
function transformNavigationDirectoryResponse(response) {
    return response;
}
function transformLinksResponse(response) {
    return response;
}

var NAVIGATION_DIRECTORY_MOCK_RESPONSE = {
    tree: [
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Policies',
            path: '/policies',
            isVisible: true,
            children: [],
            icon: 'key',
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Reports',
            path: '/reports',
            isVisible: true,
            children: [],
            icon: 'chart-bar',
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Products',
            path: '/products',
            isVisible: true,
            children: [],
            icon: 'shopping-cart',
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Employees',
            path: '/employees',
            isVisible: true,
            children: [],
            icon: 'users',
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Establishment',
            path: '/establishment',
            isVisible: true,
            icon: 'address-card',
            children: [
                {
                    id: '169530d4-f3b9-11eb-9a03-0242ac130003',
                    label: 'General',
                    path: '/establishment/general',
                    isVisible: true,
                    children: [],
                },
                {
                    id: '169530d4-f3b9-11eb-9a03-0242ac130003',
                    label: 'Stations',
                    path: '/establishments/stations',
                    isVisible: true,
                    children: [],
                },
            ],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Features',
            path: '/feature-toggle',
            isVisible: true,
            icon: 'flag',
            children: [],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Settings',
            path: '/settings',
            isVisible: true,
            icon: 'cog',
            children: [],
        },
    ],
    namedNodes: [
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'About',
            path: '/about',
            isVisible: true,
            children: [],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Home',
            path: '/',
            isVisible: true,
            children: [],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Login',
            path: '/auth',
            isVisible: true,
            children: [],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Logout',
            path: '/auth/logout',
            isVisible: true,
            children: [],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'change password',
            path: '/change-password',
            isVisible: true,
            children: [],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Help',
            path: '/help',
            isVisible: true,
            children: [],
        },
    ],
};
var NAVIGATION_DIRECTORY_POST_PAYLOAD_SUCCESS = {
    tree: [
        {
            label: 'Establishment',
            path: '/establishment',
            icon: 'restaurant-building',
            isVisible: true,
            children: [
                {
                    label: 'General',
                    path: '/general',
                    isVisible: true,
                    children: [],
                },
                {
                    label: 'Stations',
                    path: '/establishments/stations',
                    isVisible: true,
                    children: [],
                },
            ],
        },
        {
            label: 'Features',
            path: '/features',
            isVisible: true,
            icon: 'exclaimation-point',
            children: [],
        },
    ],
    namedNodes: [
        {
            label: 'Help',
            path: '/help',
            isVisible: true,
            icon: 'question-mark',
            children: [],
        },
        {
            label: 'change password',
            path: '/change-password',
            isVisible: true,
            children: [],
        },
    ],
};
var NAVIGATION_DIRECTORY_MOCK_INVALID_RESPONSE = {
    tree: [
        {
            label: 'Establishment',
            icon: 'address-card',
            children: [
                {
                    label: 'General',
                    children: [],
                },
                {
                    id: '169530d4-f3b9-11eb-9a03-0242ac130003',
                    label: 'Stations',
                    path: '/establishments/stations',
                },
            ],
        },
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            label: 'Features',
            children: [],
        },
    ],
    namedNodes: [
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            children: [],
        },
        {
            label: 'change password',
            path: '/change-password',
        },
    ],
};
var NAVIGATION_DIRECTORY_CORTEX_RESPONSE = {
    tree: [
        {
            id: '1',
            label: 'Authorization',
            path: '/authorization',
            isVisible: true,
            icon: 'key',
            children: [
                {
                    id: '2',
                    label: 'Permissions',
                    path: '/authorization/permissions',
                    isVisible: true,
                    icon: 'key',
                    children: [],
                },
                {
                    id: '3',
                    label: 'Users',
                    path: '/authorization/users',
                    isVisible: true,
                    icon: 'users',
                    children: [],
                },
                {
                    id: '4',
                    label: 'Roles',
                    path: '/authorization/roles',
                    isVisible: true,
                    icon: '',
                    children: [],
                }
            ],
        },
        {
            id: '5',
            label: 'Policies',
            path: '/policies',
            isVisible: true,
            children: [],
            icon: 'key',
        },
        {
            id: '6',
            label: 'Features',
            path: '/feature-toggle',
            isVisible: true,
            icon: 'flag',
            children: [],
        },
        {
            id: '7',
            label: 'Greeter',
            path: '/greeter',
            isVisible: true,
            icon: 'handshake',
            children: [],
        },
        {
            id: '8',
            label: 'Stations',
            path: '/station-control',
            isVisible: true,
            icon: 'tablet-alt',
            children: [],
        },
    ],
    namedNodes: [
        {
            id: '4',
            label: 'About',
            path: '/about',
            isVisible: true,
            children: [],
        },
        {
            id: '7',
            label: 'Home',
            path: '/',
            isVisible: true,
            children: [],
        },
        {
            id: '1',
            label: 'Login',
            path: '/auth',
            isVisible: true,
            children: [],
        },
        {
            id: '3',
            label: 'Logout',
            path: '/auth/logout',
            isVisible: true,
            children: [],
        },
        {
            id: '5',
            label: 'change password',
            path: '/change-password',
            isVisible: true,
            children: [],
        },
        {
            id: '6',
            label: 'Help',
            path: '/help',
            isVisible: true,
            children: [],
        },
    ],
};
var NAVIGATION_DIRECTORY_POST_FAIL_MISSING_PARAMS = {
    tree: [
        {
            icon: 'address-card',
            children: [
                {
                    label: 'General',
                    children: [],
                },
                {
                    path: '/establishments/stations',
                },
            ],
        },
        {
            label: 'Features',
            children: [],
        },
    ],
    namedNodes: [
        {
            id: '169530d4-f3b9-11eb-9a03-0242ac130003',
            children: [],
        },
        {
            label: 'change password',
            path: '/change-password',
        },
    ],
};
var NAVIGATION_LINKS_RESPONSE = [
    {
        frontend: 'Hello',
        links: [{
                id: '169530d4-f3b9-11eb-9a03-0242ac130003',
                label: 'Hello One',
                path: '/hello/one',
                icon: 'key',
                iconPack: 'key',
                isPathAbsolute: false,
                actions: [
                    'hello1:read'
                ],
            },
            {
                id: '16953354-f3b9-11eb-9a03-0242ac130003',
                label: 'Hello Two',
                path: '/hello/two',
                icon: 'users',
                iconPack: 'users',
                isPathAbsolute: false,
                actions: [
                    'hello2:read'
                ],
            },
            {
                id: '169537fa-f3b9-11eb-9a03-0242ac130003',
                label: 'Hello Three',
                path: '/hello/three',
                icon: 'hello',
                iconPack: 'hello',
                isPathAbsolute: false,
                actions: [
                    'hello3:read'
                ],
            }]
    }
];
var NAVIGATION_LINKS_GET_LINKS_FAIL_MISSING_LINK_PROPERTIES = [{
        app: 'testApplication',
        frontend: 'testFrontend',
        links: [{
                actions: ['testLink:read', 'testLink:write'],
            },
            {
                path: '/testLink2',
                label: 'test Link2',
                isPathAbsolute: false,
                actions: ['testLink:read', 'testLink:write'],
            }],
    }];
var NAVIGATION_LINKS_POST_MOCK_RESPONSE = 'Links created successfully';
var NAVIGATION_DIRECTORY_POST_MOCK_RESPONSE = 'Navigation post created successfully';
var NAVIGATION_LINKS_POST_PAYLOAD_SUCCESS = {
    app: 'testApplication',
    frontend: 'testFrontend',
    links: [{
            path: '/testLink',
            label: 'test Link',
            isPathAbsolute: false,
            actions: ['testLink:read', 'testLink:write'],
        },
        {
            path: '/testLink2',
            label: 'test Link2',
            isPathAbsolute: false,
            actions: ['testLink:read', 'testLink:write'],
        }],
};
var NAVIGATION_LINKS_POST_LINKS_FAIL_MISSING_LINK_PROPERTIES = {
    app: 'testApplication',
    frontend: 'testFrontend',
    links: [{
            actions: ['testLink:read', 'testLink:write'],
        },
        {
            path: '/testLink2',
            label: 'test Link2',
            isPathAbsolute: false,
            actions: ['testLink:read', 'testLink:write'],
        }],
};
var NAVIGATION_LINKS_POST_LINKS_FAIL_MISSING_APP_ID = {
    frontend: 'testFrontend',
    links: [{
            path: '/testLink2',
            label: 'test Link2',
            isPathAbsolute: false,
            actions: ['testLink:read', 'testLink:write'],
        }],
};

var fetchMockNavigation = function (transform) {
    if (transform === void 0) { transform = transformNavigationDirectoryResponse; }
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, transform(NAVIGATION_DIRECTORY_MOCK_RESPONSE)];
    }); });
};
var fetchCortexNavigation = function (transform) {
    if (transform === void 0) { transform = transformNavigationDirectoryResponse; }
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, transform(NAVIGATION_DIRECTORY_CORTEX_RESPONSE)];
    }); });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule(function (module) {
(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if ( module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(commonjsGlobal);
});
var humps_1 = humps.camelizeKeys;
var humps_2 = humps.pascalizeKeys;
var humps_3 = humps.decamelizeKeys;

// api response transform functions go here
function defaultEstablishmentTransform(establishment) {
    return humps_1(establishment);
}
function defaultEstablishmentsTransform(response) {
    return response.objects.map(defaultEstablishmentTransform);
}

var ESTABLISHMENTS_MOCK_RESPONSE = {
    meta: {
        limit: 0,
        next: '',
        offset: 0,
        previous: 0,
        time_zone: '',
        total_count: 0,
    },
    objects: [
        {
            about_access_to_location: '',
            about_description: '',
            about_title: null,
            active: true,
            address: '/resources/Address/2/',
            android_settings: '{}',
            billing_enabled: false,
            brand: '/enterprise/Brand/1/',
            brand_name: 'api-sandbox-revel',
            cancelable_by_billing: true,
            cancellation_date: null,
            client_type: 0,
            contact_name: '',
            created_by: '/enterprise/User/2/',
            created_date: '2020-01-28T12:04:59.559516',
            ctuit: false,
            currency: null,
            delivery_management: false,
            disabled_backend_for_payment: false,
            disabled_backend_for_payment_date: null,
            disabled_for_cancellation: false,
            disabled_for_payment: false,
            display_unit_bg_url: '',
            effective_from: '2020-01-28T12:04:59.485061',
            effective_to: null,
            email: 'info@revelsystems.com',
            export_type: 2,
            fax: null,
            hierarchy_type: 5,
            id: 1,
            images: [],
            information_verified: false,
            kiosk_image_url_legacy: null,
            location_account_status: null,
            location_email: null,
            location_name: null,
            lock_add_category: 0,
            lock_add_discount: false,
            lock_add_modifierclass: 0,
            logo_img: null,
            logo_url_legacy: null,
            manager: '/enterprise/User/1/',
            matrix_inventory: false,
            name: 'api-sandbox-revel',
            notes: '',
            ns_internal_id: null,
            on_boarding_completed: false,
            on_boarding_completed_date: null,
            on_boarding_started_date: null,
            payment_gateway: 0,
            phone: '415-744-1433',
            quick_books: 0,
            resource_uri: '/enterprise/Establishment/1/',
            retailer_id: null,
            revel_id: null,
            rti: false,
            sc_cert: false,
            settings: '/resources/SystemSetting/1/',
            settings_last_update: '2020-01-28T12:38:33.073556',
            show_backend_payment_warning: false,
            show_payment_warning: false,
            site_number: null,
            social_networks: [],
            sorting_id: null,
            store_number: null,
            surcharge: null,
            tax: [],
            tax_payer_num: null,
            time_worked_available: false,
            time_zone: 'US/Pacific',
            type_of_service: 0,
            updated_by: '/enterprise/User/2/',
            updated_date: '2020-01-28T12:05:00.482183',
            vip: false,
            web_reservations_key: null,
        },
    ],
};

var fetchMockEstablishments = function (transform) {
    if (transform === void 0) { transform = defaultEstablishmentsTransform; }
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, transform(ESTABLISHMENTS_MOCK_RESPONSE)];
    }); });
};

var FEATURE_PROPERTIES = {
    name: { type: 'string' },
    isInclusive: { type: 'boolean' },
    keys: {
        type: 'array',
        items: { type: 'string' },
    }
};
var FEATURE_DEFINITION = {
    feature: {
        type: 'object',
        properties: FEATURE_PROPERTIES,
        required: ['name', 'isInclusive', 'keys'],
    }
};
var FEATURES_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'array',
    items: { FEATURE_DEFINITION: FEATURE_DEFINITION },
    definitions: __assign({}, FEATURE_DEFINITION),
};
var FEATURE_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: FEATURE_PROPERTIES,
    required: ['name', 'isInclusive', 'keys'],
    definitions: __assign({}, FEATURE_DEFINITION)
};
var KEYS_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'array',
    items: {
        type: 'string'
    }
};

var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["DELETE"] = "DELETE";
})(RequestMethod || (RequestMethod = {}));

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

var validate = function (schema) { return function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var ajv, validate, isValid, errorMessage;
    return __generator(this, function (_a) {
        ajv = new Ajv({ allErrors: true, jsonPointers: true });
        require('ajv-errors')(ajv, { singleError: true });
        validate = ajv.compile(schema);
        isValid = validate(data);
        if (!isValid && validate.errors) {
            errorMessage = 'schema validation failed: ' + (validate.errors).map(function (e) { return e.message; }).join(', ');
            throw new Error(errorMessage);
        }
        return [2 /*return*/, data];
    });
}); }; };

var getApi = function (url, axios, params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                return [2 /*return*/, axios.get(url, { withCredentials: true, params: params })];
            }
            catch (e) {
                console.log('++$error', e);
                throw (e);
            }
            return [2 /*return*/];
        });
    });
};
var getData = function (axios, requestConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var url, schema, transform, params, response, validData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = requestConfig.url, schema = requestConfig.schema, transform = requestConfig.transform, params = requestConfig.params;
                return [4 /*yield*/, getApi(url, axios, params)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, validate(schema)(response.data)];
            case 2:
                validData = _a.sent();
                // console.info(`api-client returning data for ${ url }`);
                return [2 /*return*/, isFunction_1(transform) ? transform(validData) : validData];
        }
    });
}); };

var postApi = function (url, axios, payload, params, additionalConfig) {
    if (params === void 0) { params = {}; }
    if (additionalConfig === void 0) { additionalConfig = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post(url, payload, __assign({ withCredentials: true, params: params }, additionalConfig))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
var postData = function (axios, requestConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var url, schema, params, payload, requestTransform, additionalConfig, transformedPayload, data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = requestConfig.url, schema = requestConfig.schema, params = requestConfig.params, payload = requestConfig.payload, requestTransform = requestConfig.requestTransform, additionalConfig = requestConfig.additionalConfig;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                transformedPayload = isFunction_1(requestTransform) ? requestTransform(payload) : payload;
                return [4 /*yield*/, validate(schema)(transformedPayload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, postApi(url, axios, transformedPayload, params, additionalConfig)];
            case 3:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 4:
                e_1 = _a.sent();
                console.error("error sending api-client sending POST data for " + url, transformedPayload);
                throw (e_1);
            case 5: return [2 /*return*/];
        }
    });
}); };

var putApi = function (url, axios, payload, params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, axios.put(url, payload, { withCredentials: true, params: params })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
var putData = function (axios, requestConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var url, schema, params, payload, requestTransform, transformedPayload, data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = requestConfig.url, schema = requestConfig.schema, params = requestConfig.params, payload = requestConfig.payload, requestTransform = requestConfig.requestTransform;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                transformedPayload = isFunction_1(requestTransform) ? requestTransform(payload) : payload;
                return [4 /*yield*/, validate(schema)(transformedPayload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, putApi(url, axios, transformedPayload, params)];
            case 3:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 4:
                e_1 = _a.sent();
                console.error("error sending api-client sending PUT data for " + url, transformedPayload);
                throw (e_1);
            case 5: return [2 /*return*/];
        }
    });
}); };

var deleteApi = function (url, axios, params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, axios.delete(url, { withCredentials: true, params: params })];
}); }); };
var deleteData = function (axios, requestConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var url, params, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = requestConfig.url, params = requestConfig.params;
                return [4 /*yield*/, deleteApi(url, axios, params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };

var _a;
var getUrl = function (baseUrl, paths) {
    return baseUrl + paths.join('/');
};
var methods = (_a = {},
    _a[RequestMethod.GET] = getData,
    _a[RequestMethod.POST] = postData,
    _a[RequestMethod.PUT] = putData,
    _a[RequestMethod.DELETE] = deleteData,
    _a);
var makeRequest = function (axios, requestConfig) {
    return methods[requestConfig.method](axios, requestConfig);
};
var serializeParams = function (params) { return qs.stringify(params); };
var encodeParams = function (data) {
    var params = new URLSearchParams();
    for (var _i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        params.append(key, value.toString());
    }
    return params;
};

var FEATURE_MANAGE_API_PATH = 'feature/v1.0/manage';
var FEATURE_LOOKUP_API_PATH = 'feature/v1.0/lookup-keys';

// api response transform functions go here
function defaultFeatureTransform(feature) {
    return humps_1(feature);
}
function defaultFeaturesTransform(data) {
    return data.map(defaultFeatureTransform);
}
function defaultFeaturesRequestTransform(feature) {
    return feature;
}
function defaultKeysTransform(key) {
    return key;
}

/**
 * makes a GET request to <domain.com>/feature-toggle
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getFeatures = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [FEATURE_MANAGE_API_PATH]),
        schema: FEATURES_SCHEMA,
        transform: transform || defaultFeaturesTransform,
        method: RequestMethod.GET,
    });
};
/**
 * makes a GET request to <domain.com>/feature-toggle/feature/<featurename>
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 * @param {object} routeParams - ordered route parameters
 */
var getFeature = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, routeParams = _a.routeParams;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [FEATURE_MANAGE_API_PATH, routeParams.name]),
        schema: FEATURE_SCHEMA,
        transform: transform || defaultFeatureTransform,
        method: RequestMethod.GET,
    });
};
/**
 * makes a POST request to <domain.com>/feature-toggle/feature/<featureName>
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} routeParams - ordered route parameters
 * @param {object} payload - the feature data
 */
var createFeature = function (_a) {
    var config = _a.config, axios = _a.axios, routeParams = _a.routeParams, payload = _a.payload, transform = _a.transform;
    return new Promise(function (resolve, reject) {
        makeRequest(axios, {
            url: getUrl(config.baseUrl, [FEATURE_MANAGE_API_PATH, routeParams.name]),
            schema: FEATURE_SCHEMA,
            method: RequestMethod.POST,
            payload: payload,
            requestTransform: transform || defaultFeaturesRequestTransform,
        })
            // eslint-disable-next-line camelcase
            .then(function (feature) {
            resolve(feature.name);
        })
            .catch(reject);
    });
};
/**
 * makes a PUT request to <domain.com>/feature-toggle/feature/<featureName>
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} routeParams - ordered Route parameters
 * @param {object} payload - the feature data
 */
var updateFeature = function (_a) {
    var config = _a.config, axios = _a.axios, routeParams = _a.routeParams, payload = _a.payload, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [FEATURE_MANAGE_API_PATH, routeParams.name]),
        schema: FEATURE_SCHEMA,
        method: RequestMethod.PUT,
        payload: payload,
        requestTransform: transform || defaultFeaturesRequestTransform,
    });
};
/**
 * makes a DELETE request to <domain.com>/feature-toggle/feature/<featureName>
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} routeParams - ordered route parameters
 */
var deleteFeature = function (_a) {
    var config = _a.config, axios = _a.axios, routeParams = _a.routeParams;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [FEATURE_MANAGE_API_PATH, routeParams.name]),
        method: RequestMethod.DELETE
    });
};
/**
 * makes a GET request to <domain.com>/feature-toggle
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getKeys = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, featureName = _a.featureName;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [FEATURE_LOOKUP_API_PATH, featureName]),
        schema: KEYS_SCHEMA,
        transform: transform || defaultKeysTransform,
        method: RequestMethod.GET,
    });
};

var FEATURES_MOCK_RESPONSE = [
    {
        name: 'testFeature1',
        isInclusive: true,
        keys: ['clientA|1', 'clientB|2', 'clientC|3'],
    },
    {
        name: 'testFeature2',
        isInclusive: false,
        keys: ['clientD|1', 'clientF|2', 'clientG|3'],
    },
    {
        name: 'testFeature3',
        isInclusive: true,
        keys: [],
    },
    {
        name: 'testFeature4',
        isInclusive: false,
        keys: ['clientY|1', 'clientZ|2'],
    },
    {
        name: 'testFeature5',
        isInclusive: true,
        keys: ['clientQ|1', 'clientU|2', 'clientI|3'],
    },
];
var KEYS_MOCK_RESPONSE = ['testKey1', 'testKey2', 'testKey3'];

function fetchMockFeatures(options) {
    return __awaiter(this, void 0, void 0, function () {
        var transformFunc;
        return __generator(this, function (_a) {
            transformFunc = (options && options.transform) || defaultFeaturesTransform;
            return [2 /*return*/, transformFunc(FEATURES_MOCK_RESPONSE)];
        });
    });
}
var fetchMockFeature = function (_a) {
    var _b = _a.transform, transform = _b === void 0 ? defaultFeatureTransform : _b, routeParams = _a.routeParams;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, transform(FEATURES_MOCK_RESPONSE.find(function (feature) {
                    console.log(feature);
                    return feature.name === routeParams.name;
                }))];
        });
    });
};
function fetchMockKeys(options) {
    return __awaiter(this, void 0, void 0, function () {
        var transformFunc;
        return __generator(this, function (_a) {
            transformFunc = (options === null || options === void 0 ? void 0 : options.transform) || defaultKeysTransform;
            return [2 /*return*/, transformFunc(KEYS_MOCK_RESPONSE)];
        });
    });
}

var STATION_PROPERTIES = {
    client: { type: 'string' },
    establishment: { type: 'string' },
    station: { type: 'string' },
    logLevel: {
        enum: ['0', '1', '2', '3', '4'],
        type: 'string'
    },
};
var STATION_DEFINITION = {
    station: {
        type: 'object',
        properties: STATION_PROPERTIES,
        required: ['client', 'establishment', 'station'],
    }
};
var STATIONS_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'array',
    items: { STATION_DEFINITION: STATION_DEFINITION },
    definitions: __assign({}, STATION_DEFINITION),
};
var STATION_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: STATION_PROPERTIES,
    required: ['client', 'establishment', 'station'],
    definitions: __assign({}, STATION_DEFINITION)
};

var STATION_MANAGE_API_PATH = 'station/v1.0/manage/logs';

// api response transform functions go here
function defaultStationTransform(station) {
    return humps_1(station);
}
function defaultStationsTransform(stations) {
    return stations.map(defaultStationTransform);
}

/**
 * makes a GET request to <domain.com>/station-control
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getStations = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [STATION_MANAGE_API_PATH]),
        schema: STATIONS_SCHEMA,
        transform: transform || defaultStationsTransform,
        method: RequestMethod.GET,
    });
};
/**
 * makes a PUT request to <domain.com>/feature-toggle/feature/<featureName>
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} routeParams - ordered Route parameters
 * @param {object} payload - the feature data
 */
var udpateStationLogLevel = function (_a) {
    var config = _a.config, axios = _a.axios, routeParams = _a.routeParams, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [STATION_MANAGE_API_PATH, routeParams.client, routeParams.establishment, routeParams.station, routeParams.logLevel]),
        schema: STATION_SCHEMA,
        method: RequestMethod.GET,
        transform: transform || defaultStationTransform,
    });
};

var LogLevel;
(function (LogLevel) {
    LogLevel["Fatal"] = "0";
    LogLevel["Error"] = "1";
    LogLevel["Warn"] = "2";
    LogLevel["Info"] = "3";
    LogLevel["Debug"] = "4";
})(LogLevel || (LogLevel = {}));

var STATIONS_MOCK_RESPONSE = [
    {
        client: 'testClient',
        establishment: '1',
        station: 'POS1',
        logLevel: LogLevel.Info,
    },
    {
        client: 'testClient',
        establishment: '1',
        station: 'POS2',
        logLevel: LogLevel.Debug,
    },
    {
        client: 'testClient',
        establishment: '2',
        station: 'POS1',
        logLevel: LogLevel.Fatal,
    },
    {
        client: 'testClient',
        establishment: '2',
        station: 'POS2',
        logLevel: LogLevel.Warn,
    },
    {
        client: 'testClient',
        establishment: '3',
        station: 'POS1',
        logLevel: LogLevel.Error,
    },
    {
        client: 'testClient',
        establishment: '3',
        station: 'POS2',
        logLevel: LogLevel.Error,
    },
    {
        client: 'testClient',
        establishment: '3',
        station: 'Kiosk',
        logLevel: LogLevel.Error,
    },
    {
        client: 'testClient',
        establishment: '3',
        station: 'KDS',
        logLevel: LogLevel.Error,
    },
];

function fetchMockStations(options) {
    return __awaiter(this, void 0, void 0, function () {
        var transformFunc;
        return __generator(this, function (_a) {
            transformFunc = (options && options.transform) || defaultStationsTransform;
            return [2 /*return*/, transformFunc(STATIONS_MOCK_RESPONSE)];
        });
    });
}

var POLICY_DETAILS_PROPERTIES = {
    services: {
        type: 'object',
        patternProperties: {
            '^[A-Za-z_][A-Za-z0-9_]*$': {
                type: 'array',
                items: { type: 'string' },
                minItems: 1
            },
        },
    },
    establishments: { type: 'array', items: { type: 'string' }, minItems: 1 },
};
var POLICY_DETAILS_DEFINITION = {
    policyDetails: {
        type: 'object',
        properties: POLICY_DETAILS_PROPERTIES,
        required: ['services', 'establishments']
    }
};
var POLICIES_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'array',
    items: { $ref: '#/definitions/policy' },
    definitions: {
        policy: {
            type: 'object',
            properties: {
                policy_id: { type: 'string' },
                policy: {
                    type: 'object',
                    properties: POLICY_DETAILS_PROPERTIES,
                    required: ['services', 'establishments'],
                }
            },
            required: ['policy', 'policy_id', 'policy_name']
        }
    },
};
var POLICY_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: {
        policyId: { type: 'string' },
        policy_name: { type: 'string' },
        policy: { $ref: '#/definitions/policyDetails' }
    },
    required: ['policy', 'policy_id', 'policy_name'],
    definitions: __assign({}, POLICY_DETAILS_DEFINITION)
};
var POLICY_PAYLOAD_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: {
        policy_name: { type: 'string' },
        policy: { $ref: '#/definitions/policyDetails' }
    },
    required: ['policy', 'policy_name'],
    definitions: __assign({}, POLICY_DETAILS_DEFINITION)
};
var POLICY_DETAILS_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: POLICY_DETAILS_PROPERTIES,
    required: ['services', 'establishments'],
};

var POLICIES_API_PATH = 'authz/policies';
var POLICY_API_PATH = 'authz/policy';

// api response transform functions go here
function defaultPolicyTransform(policy) {
    return humps_1(policy);
}
function defaultPoliciesTransform(data) {
    return data.map(defaultPolicyTransform);
}
function defaultPoliciesRequestTransform(data) {
    return {
        policy_name: data.policyName,
        policy: data.policy
    };
}
function getPolicyDetailsOnly(policy) {
    var camelized = defaultPolicyTransform(policy);
    return camelized.policy;
}

/**
 * makes a GET request to <domain.com>/policies
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getPolicies = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [POLICIES_API_PATH]),
        schema: POLICIES_SCHEMA,
        transform: transform || defaultPoliciesTransform,
        method: RequestMethod.GET,
        params: params,
    });
};
/**
 * makes a GET request to <domain.com>/policy
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 * @param {object} params - query parameters
 */
var getPolicy = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [POLICY_API_PATH]),
        schema: POLICY_SCHEMA,
        transform: transform || defaultPolicyTransform,
        method: RequestMethod.GET,
        params: params,
    });
};
/**
 * makes a POST request to <domain.com>/policy
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} params - query parameters
 * @param {object} payload - the policy data
 */
var createPolicy = function (_a) {
    var config = _a.config, axios = _a.axios, params = _a.params, payload = _a.payload, transform = _a.transform;
    return new Promise(function (resolve, reject) {
        makeRequest(axios, {
            url: getUrl(config.baseUrl, [POLICY_API_PATH]),
            schema: POLICY_PAYLOAD_SCHEMA,
            method: RequestMethod.POST,
            params: params,
            payload: payload,
            requestTransform: transform || defaultPoliciesRequestTransform,
        })
            // eslint-disable-next-line camelcase
            .then(function (_a) {
            var policy_id = _a.policy_id;
            resolve(policy_id);
        })
            .catch(reject);
    });
};
/**
 * makes a POST request to <domain.com>/policy
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} params - query parameters
 * @param {object} payload - the policy data
 */
var updatePolicy = function (_a) {
    var config = _a.config, axios = _a.axios, params = _a.params, payload = _a.payload, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [POLICY_API_PATH]),
        schema: POLICY_PAYLOAD_SCHEMA,
        method: RequestMethod.POST,
        params: params,
        payload: payload,
        requestTransform: transform || defaultPoliciesRequestTransform,
    });
};
/**
 * makes a DELETE request to <domain.com>/policy
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {object} params - query parameters
 */
var deletePolicy = function (_a) {
    var config = _a.config, axios = _a.axios, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [POLICY_API_PATH]),
        method: RequestMethod.DELETE,
        params: params
    });
};

var POLICIES_MOCK_RESPONSE = [
    {
        policy_id: '53709b5d-9bd8-49c3-a04d-0d4693c9b4d2',
        policy_name: 'test1',
        policy: {
            services: {
                testSvc3: ['mock:Write', 'mock:Read'],
                testSvc4: ['mock:Write', 'mock:Read'],
            },
            establishments: ['Estab2', 'Estab3'],
        },
    },
    {
        policy_id: 'f46f7853-521b-4c97-af2d-142cf58c6397',
        policy_name: 'test2',
        policy: {
            services: {
                testSvc3: ['mock:Write', 'mock:Read'],
            },
            establishments: ['Estab2'],
        },
    },
    {
        policy_id: 'a099b520-e65e-4095-9862-68d0ad9f2d5a',
        policy_name: 'test3',
        policy: {
            services: {
                testSvc3: ['mock:Write', 'mock:Read'],
            },
            establishments: ['Estab2'],
        },
    },
    {
        policy_id: '1a6bacc4-6810-440e-8cbe-97266513ec82',
        policy_name: 'test4',
        policy: {
            services: {
                testSvc3: ['mock:Write', 'mock:Read'],
            },
            establishments: ['Estab2'],
        },
    },
    {
        policy_id: 'fbcb25f0-4920-443e-b952-60b6ec763b83',
        policy_name: 'test5',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: '50c401d1-5326-48de-b90e-594013aff509',
        policy_name: 'test6',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: 'a44d3a38-ad1d-416c-a54d-f8db28f9c194',
        policy_name: 'test7',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: '53abf94c-0e2a-466b-8ec2-e0e15d7051f1',
        policy_name: 'test8',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: 'fce7e7c4-18f6-4f1b-9379-4f44fc16a2c0',
        policy_name: 'test9',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: '235f3ed7-2368-4963-81e6-47aed1f9ea9f',
        policy_name: 'test10',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: '7989bb71-85ae-4bba-a396-174709d9f385',
        policy_name: 'test11',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: '8e9a5b7b-ffe0-4fb8-a418-2ad65c276b8c',
        policy_name: 'test12',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: '87876901-2318-4257-bceb-b384d7557c80',
        policy_name: 'test13',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: 'd360bf5f-8438-45d0-8f0b-553b6a1ce94b',
        policy_name: 'test14',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: 'b5b10d9f-4a38-4d73-b0b6-ceed68d3c555',
        policy_name: 'test15',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: 'cf2530bb-3817-4991-8b8d-87caaeedaad9',
        policy_name: 'test16',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
    {
        policy_id: 'ae5a4cb6-b675-4f83-8ebb-b2b4f1223c6d',
        policy_name: 'test17',
        policy: {
            services: {
                testSvc1: ['user:Read', 'mock:Write'],
            },
            establishments: ['Estab1'],
        },
    },
];

function fetchMockPolicies(options) {
    return __awaiter(this, void 0, void 0, function () {
        var transformFunc;
        return __generator(this, function (_a) {
            transformFunc = (options && options.transform) || defaultPoliciesTransform;
            return [2 /*return*/, transformFunc(POLICIES_MOCK_RESPONSE)];
        });
    });
}
var fetchMockPolicy = function (_a) {
    var _b = _a.transform, transform = _b === void 0 ? defaultPolicyTransform : _b, params = _a.params;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, transform(POLICIES_MOCK_RESPONSE.find(function (policy) { return policy.policy_id === params.policyId; }))];
        });
    });
};

var CP_MANAGER_MOCK_RESPONSE = {
    storeLogo: 'https://cdn.revelsystems.com/assets/logo.svg',
    order: {
        orderId: '123',
        orderItems: [{
                name: 'Grilled Smoked Chicken',
                quantity: 10,
                price: 9.99,
                modifiers: [{
                        quantity: 3,
                        name: 'Chili Sauce',
                    }, {
                        quantity: 1,
                        name: 'Tomatoes',
                    }, {
                        quantity: 2,
                        name: 'Carrots',
                    }, {
                        quantity: 1,
                        name: 'Pineapple',
                    }, {
                        quantity: 1,
                        name: 'Italian Ham',
                    }]
            }, {
                name: 'Tater Tots',
                quantity: 1,
                price: 3.99,
                modifiers: null
            }]
    }
};

function defaultCpManagerTransform(cp_manager) {
    return humps_1(cp_manager);
}

var getMockCpManager = function (transform) {
    if (transform === void 0) { transform = defaultCpManagerTransform; }
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, transform(CP_MANAGER_MOCK_RESPONSE)];
    }); });
};

var ESTABLISHMENTS_TREE_MOCK_RESPONSE = {
    active: {
        establishments: [1],
        node_id: 1,
        node_type: 1,
    },
    groups: [],
    hierarchy: [{
            children: [],
            ht_type: 5,
            id: 1,
            name: 'wctests'
        }],
    tree: [{
            access_establishments: [{
                    id: 1,
                    name: 'wctests',
                }],
            base_establishment: 1,
            editable: true,
            name: 'wctests',
            node_id: 1,
            parent_id: null,
            type: 0
        }],
    permissions: {
        'establishment.establishment': 15,
        'navigation.group': 15,
        'navigation.group.active': 15,
        'navigation.group.base_establishment': 15,
        'navigation.group.moving': 15,
        'navigation.group.name': 15,
        'navigation.tree': 15,
        'navigation.tree.base_establishment': 15,
        'navigation.tree.moving': 15,
        'navigation.tree.name': 15,
    },
    establishment_name_max_lenght: 30,
    multiple_establishments: true,
    next_id: 2,
    meta: {},
    ems_v2_division: false
};

function defaultEstablishmentsTreeTransform(establishments_tree) {
    return humps_1(establishments_tree, function (key, convert, options) {
        // dont convert permission keys ie. navigation.tree.base_establishment
        return /^([a-z_]+\.[a-z_]+\.[a-z_]+)$/.test(key) ? key : convert(key, options);
    });
}
function loadEstablishmentsTreeTransform(payload) {
    return humps_3(payload, { separator: '_' });
}

var fetchMockEstablishmentsTree = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, defaultEstablishmentsTreeTransform(ESTABLISHMENTS_TREE_MOCK_RESPONSE)];
}); }); };

var BASE_LINK_LIST_SCHEMA = function (additionalProps, requiredProps) { return ({
    type: 'array',
    items: {
        type: 'object',
        required: requiredProps,
        dependencies: {
            iconPack: ['icon']
        },
        properties: __assign({ isPathAbsolute: {
                default: false,
                type: 'boolean'
            }, label: {
                type: 'string',
            }, path: {
                type: 'string',
            }, icon: {
                type: 'string',
            }, iconPack: {
                type: 'string',
            }, actions: {
                type: 'array',
                items: {
                    type: 'string',
                }
            } }, additionalProps),
    },
}); };
var BASE_NAVIGATION_SCHEMA = function (additionalProps, requiredProps) { return ({
    type: 'array',
    items: {
        type: 'object',
        required: requiredProps,
        additionalProperties: false,
        properties: __assign({ id: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$'
            }, label: {
                type: 'string'
            }, path: {
                type: 'string'
            }, isVisible: {
                type: 'boolean',
            }, icon: {
                type: 'string'
            }, children: {
                type: 'array'
            } }, additionalProps)
    }
}); };
var NAVIGATION_WITH_ID_SCHEMA = BASE_NAVIGATION_SCHEMA({ id: { type: 'string', format: 'uuid' } }, ['label', 'id', 'path', 'isVisible', 'children']);
var NAVIGATION_NO_ID_SCHEMA = BASE_NAVIGATION_SCHEMA({}, ['label', 'path', 'isVisible', 'children']);
var LINK_LIST_WITH_ID_SCHEMA = BASE_LINK_LIST_SCHEMA({ id: { type: 'string', format: 'uuid' } }, ['label', 'path', 'id', 'actions', 'isPathAbsolute']);
var LINK_LIST_NO_ID_SCHEMA = BASE_LINK_LIST_SCHEMA({}, ['label', 'path', 'actions', 'isPathAbsolute']);
var NAVIGATION_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    definitions: {
        navigation_id_required: {
            type: 'object',
            required: ['tree'],
            properties: {
                tree: NAVIGATION_WITH_ID_SCHEMA,
                namedNodes: NAVIGATION_WITH_ID_SCHEMA,
            },
        },
        navigation_no_id: {
            type: 'object',
            required: ['tree'],
            properties: {
                tree: NAVIGATION_NO_ID_SCHEMA,
                namedNodes: NAVIGATION_NO_ID_SCHEMA,
            },
        },
        links_get_schema: {
            type: 'array',
            items: {
                type: 'object',
                required: ['frontend', 'links'],
                properties: {
                    frontend: {
                        type: 'string',
                    },
                    links: LINK_LIST_WITH_ID_SCHEMA
                }
            }
        },
        links_post_schema: {
            type: 'object',
            required: ['app', 'frontend', 'links'],
            properties: {
                frontend: {
                    type: 'string',
                },
                links: LINK_LIST_NO_ID_SCHEMA
            }
        },
    },
};

var NAVIGATION_API_PATH = 'navigation';
var LINK_API_PATH = 'links';

// primary methods for interacting with api client
/**
 * makes a GET request to <domain.com>/navigation
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getNavigation = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [NAVIGATION_API_PATH]),
        schema: NAVIGATION_SCHEMA.definitions.navigation_id_required,
        transform: transform || transformNavigationDirectoryResponse,
        params: params,
        method: RequestMethod.GET,
    });
};
/**
 * makes a POST request to <domain.com>/navigation
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var postNavigation = function (_a) {
    var config = _a.config, axios = _a.axios, payload = _a.payload;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [NAVIGATION_API_PATH]),
        schema: NAVIGATION_SCHEMA.definitions.navigation_no_id,
        method: RequestMethod.POST,
        payload: payload
    });
};
/**
 * makes a GET request to <domain.com>/links
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getLinks = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [LINK_API_PATH]),
        schema: NAVIGATION_SCHEMA.definitions.links_get_schema,
        transform: transform || transformLinksResponse,
        params: params,
        method: RequestMethod.GET,
    });
};
/**
 * makes a POST request to <domain.com>/links
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 */
var postLinks = function (_a) {
    var config = _a.config, axios = _a.axios, payload = _a.payload;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [LINK_API_PATH]),
        schema: NAVIGATION_SCHEMA.definitions.links_post_schema,
        payload: payload,
        method: RequestMethod.POST,
    });
};

var ESTABLISHMENTS_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: {
        meta: { type: 'object' },
        objects: {
            type: 'array',
            items: { $ref: '#/definitions/establishment' },
        }
    },
    required: ['meta', 'objects'],
    definitions: {
        establishment: {
            type: 'object',
            properties: {
                about_access_to_location: { type: 'string' },
                about_description: { type: 'string' },
                active: { type: 'boolean' },
            },
        },
    },
};

var ESTABLISHMENTS_API_PATH = 'enterprise/Establishment';

// primary methods for interacting with api client
/**
 * makes a GET request to <domain.com>/establishments
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getEstablishments = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [ESTABLISHMENTS_API_PATH]),
        schema: ESTABLISHMENTS_SCHEMA,
        transform: transform || defaultEstablishmentsTransform,
        method: RequestMethod.GET,
    });
};
/**
 * makes a GET request to <domain.com>/establishments/id
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {array} transforms - any number of functions for manipulating response data.
 */
var getEstablishmentById = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [ESTABLISHMENTS_API_PATH, params.id]),
        schema: ESTABLISHMENTS_SCHEMA.definitions.establishment,
        transform: transform || defaultEstablishmentTransform,
        method: RequestMethod.GET,
    });
};

var GREET_API_PATH = 'greeter/test';

var GREET_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'string'
};

/**
 * makes a GET request to <domain.com>/policies
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getGreeting = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [GREET_API_PATH]),
        schema: GREET_SCHEMA,
        transform: transform,
        method: RequestMethod.GET
    });
};

var CP_MANAGER_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: {
        storeLogo: { type: 'string' },
        order: {
            type: 'object',
            properties: {
                orderId: { type: 'string' },
                orderItems: {
                    type: 'array',
                    items: { $ref: '#/definitions/orderItem' }
                },
            },
            required: ['orderId', 'orderItems'],
        }
    },
    required: ['storeLogo', 'order'],
    definitions: {
        orderItem: {
            type: 'object',
            properties: {
                name: { type: 'string' },
                quantity: { type: 'number' },
                price: { type: 'number' },
                modifiers: {
                    anyOf: [{
                            type: 'array',
                            items: { $ref: '#/definitions/modifier' }
                        }, {
                            type: 'null',
                        }]
                },
            },
            required: ['name', 'quantity', 'price']
        },
        modifier: {
            type: 'object',
            properties: {
                quantity: { type: 'number' },
                name: { type: 'string' },
            },
            required: ['name', 'quantity']
        },
    },
};

var CP_MANAGER_API_PATH = 'cp-manager';

/**
 * makes a GET request to cp_manager
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 * @param {object} params - query parameters - orderId and clientId in this case
 */
var getCpManager = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform, params = _a.params;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [CP_MANAGER_API_PATH]),
        schema: CP_MANAGER_SCHEMA,
        transform: transform || defaultCpManagerTransform,
        method: RequestMethod.GET,
        params: params,
    });
};

var ESTABLISHMENTS_TREE_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: {
        active: {
            type: 'object',
            properties: {
                establishments: {
                    type: 'array',
                    items: {
                        type: 'number',
                    }
                },
            },
            required: ['establishments']
        },
        groups: {
            type: 'array',
            items: {
                type: 'array'
            }
        },
        hierarchy: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    children: {
                        type: 'array'
                    },
                    id: {
                        type: 'number'
                    },
                    name: {
                        type: 'string',
                    },
                    ht_type: {
                        type: 'number'
                    }
                }
            }
        },
        tree: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    access_establishments: {
                        type: 'array',
                        properties: {
                            id: {
                                type: 'number'
                            },
                            name: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        },
        permissions: {
            type: 'object',
        }
    },
    required: ['active', 'groups', 'permissions', 'hierarchy', 'tree'],
};
var LOAD_ESTABLISHMENTS_TREE_RAW_SCHEMA = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: {
        establishments: { type: 'array', items: { type: 'number' } },
        establishment: { type: 'number' },
        node_type: { type: 'number' },
        node_id: { type: 'number' },
        location: { type: 'string' }
    },
    required: ['establishments', 'establishment', 'node_type', 'node_id', 'location']
};

var ESTABLISHMENTS_TREE_API_PATH = '/dashboard/api/v1/EstablishmentTree';
var LOAD_ESTABLISHMENTS_TREE_API_PATH = '/navigation/load_establishment_tree/';

/**
 * makes a GET request to establishments_tree
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var getEstablishmentsTree = function (_a) {
    var config = _a.config, axios = _a.axios, transform = _a.transform;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [ESTABLISHMENTS_TREE_API_PATH]),
        schema: ESTABLISHMENTS_TREE_SCHEMA,
        transform: transform || defaultEstablishmentsTreeTransform,
        method: RequestMethod.GET
    });
};
/**
 * makes a GET request to establishments_tree
 * @param {object} config - config object.
 * @param {object} axios - an axios instance.
 * @param {function} transform - function for manipulating response data.
 */
var loadEstablishmentTree = function (_a) {
    var config = _a.config, axios = _a.axios, payload = _a.payload;
    return makeRequest(axios, {
        url: getUrl(config.baseUrl, [LOAD_ESTABLISHMENTS_TREE_API_PATH]),
        schema: LOAD_ESTABLISHMENTS_TREE_RAW_SCHEMA,
        payload: payload,
        method: RequestMethod.POST,
        requestTransform: loadEstablishmentsTreeTransform,
        additionalConfig: {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            transformRequest: encodeParams,
        }
    });
};

export { CP_MANAGER_API_PATH, CP_MANAGER_MOCK_RESPONSE, CP_MANAGER_SCHEMA, ESTABLISHMENTS_API_PATH, ESTABLISHMENTS_MOCK_RESPONSE, ESTABLISHMENTS_SCHEMA, ESTABLISHMENTS_TREE_API_PATH, ESTABLISHMENTS_TREE_MOCK_RESPONSE, ESTABLISHMENTS_TREE_SCHEMA, FEATURES_MOCK_RESPONSE, FEATURES_SCHEMA, FEATURE_SCHEMA, GREET_API_PATH, KEYS_MOCK_RESPONSE, KEYS_SCHEMA, LINK_API_PATH, LOAD_ESTABLISHMENTS_TREE_API_PATH, LOAD_ESTABLISHMENTS_TREE_RAW_SCHEMA, LogLevel, NAVIGATION_API_PATH, NAVIGATION_DIRECTORY_CORTEX_RESPONSE, NAVIGATION_DIRECTORY_MOCK_INVALID_RESPONSE, NAVIGATION_DIRECTORY_MOCK_RESPONSE, NAVIGATION_DIRECTORY_POST_FAIL_MISSING_PARAMS, NAVIGATION_DIRECTORY_POST_MOCK_RESPONSE, NAVIGATION_DIRECTORY_POST_PAYLOAD_SUCCESS, NAVIGATION_LINKS_GET_LINKS_FAIL_MISSING_LINK_PROPERTIES, NAVIGATION_LINKS_POST_LINKS_FAIL_MISSING_APP_ID, NAVIGATION_LINKS_POST_LINKS_FAIL_MISSING_LINK_PROPERTIES, NAVIGATION_LINKS_POST_MOCK_RESPONSE, NAVIGATION_LINKS_POST_PAYLOAD_SUCCESS, NAVIGATION_LINKS_RESPONSE, NAVIGATION_SCHEMA, POLICIES_API_PATH, POLICIES_MOCK_RESPONSE, POLICIES_SCHEMA, POLICY_API_PATH, POLICY_DETAILS_SCHEMA, POLICY_PAYLOAD_SCHEMA, POLICY_SCHEMA, RequestMethod, STATIONS_MOCK_RESPONSE, STATIONS_SCHEMA, STATION_SCHEMA, createFeature, createPolicy, defaultCpManagerTransform, defaultEstablishmentTransform, defaultEstablishmentsTransform, defaultEstablishmentsTreeTransform, defaultFeatureTransform, defaultFeaturesRequestTransform, defaultFeaturesTransform, defaultKeysTransform, defaultPoliciesRequestTransform, defaultPoliciesTransform, defaultPolicyTransform, defaultStationTransform, defaultStationsTransform, deleteData, deleteFeature, deletePolicy, encodeParams, fetchCortexNavigation, fetchMockEstablishments, fetchMockEstablishmentsTree, fetchMockFeature, fetchMockFeatures, fetchMockKeys, fetchMockNavigation, fetchMockPolicies, fetchMockPolicy, fetchMockStations, getCpManager, getData, getEstablishmentById, getEstablishments, getEstablishmentsTree, getFeature, getFeatures, getGreeting, getKeys, getLinks, getMockCpManager, getNavigation, getPolicies, getPolicy, getPolicyDetailsOnly, getStations, getUrl, loadEstablishmentTree, loadEstablishmentsTreeTransform, makeRequest, postData, postLinks, postNavigation, putData, serializeParams, transformLinksResponse, transformNavigationDirectoryResponse, udpateStationLogLevel, updateFeature, updatePolicy, validate };
